// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader_with_text-module__container--MtIqQ{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.loader_with_text-module__text--3bxy7{margin-left:8px}\n", ""]);
// Exports
exports.locals = {
	"container": "loader_with_text-module__container--MtIqQ",
	"text": "loader_with_text-module__text--3bxy7"
};
module.exports = exports;
